module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("At five o’clock Howard Dunne came into Gray’s office and sat down. He was wound up as tightly as a steel spring. Gray braced himself. He waited, and so did Dunne.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Presently Gray asked, “Is it hard to start?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne looked at Gray, seemed to catch himself, and glanced away again.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes,” he said. “I want to talk. But I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What would you like to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne didn’t answer. The tension grew. Gray waited, feeling more and more that he must be careful not to make any wrong moves. Dunne was facing a crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m just sitting here saying nothing,” Dunne said, after a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray took out cigarettes and held the pack out to Dunne, who took one. Both men lit up. Then, suddenly, Dunne crushed out his cigarette in the ashtray beside him and said, “Do you still have my pipe?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes,” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’d like it back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What does that mean?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said angrily, “I just want my pipe back!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray took the pipe out of his desk drawer and looked at it, watching Dunne at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Here it is,” he said. “It’s a good-looking pipe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne didn’t answer. He thrust the pipe into his side pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s more than a pipe, isn’t it?” Gray asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No answer.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Did your father use a pipe?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, he did. I’d almost forgotten that. A pipe—and a key ring. I wasn’t allowed to have a key to the house. Not till after my father left.” He stopped. It wasn’t merely a pause. Dunne’s whole body stopped. He seemed frozen and immobilized.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Again Gray waited. Dunne’s tension increased.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A sound of voices grew louder. They didn’t stop. Conversation and laughter seemed to make eddies in the watchful air.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “Excuse me,” and got up. He went into the outer office. The outer door was wide open, and, a little way down the hall, a group of people were laughing together. Gray closed the door, came back and re-entered his office, closing that door, too. Even before he sat down, he realized that the tension in the air had subtly lessened.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Something had changed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Howard Dunne had shifted his position. He was more relaxed now, the tightness about his eyes smoothed out, his whole body settled back in the chair. He gave Gray a glance that seemed to reveal relief.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, “What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nothing. I guess I must have left the door open when I came in. Sorry you had to get up and close it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s all right,” Gray said. “Would you like to open it again?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“We’re not talking about the same door. I mean the real one. The office door. You haven’t shut me out. That’s what you mean, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray smiled too.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re the one who said it, though,” he said. “So the important point is why you thought it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I guess it’s the idea of doors,” Dunne said, almost casually. “Keeping Sam out. Mary said Doctor Bronson had talked to her. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s all right,” Gray said. “How is it working out?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fine, as far as Mary goes. But … did you talk to Sam?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You didn’t get anywhere, did you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said carefully, “Do you remember how much you distrusted me when you first came here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I distrusted everybody. But especially you. Yes, I remember. It’s different now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You trust me somewhat more now,” Gray said. “Sam’s attitude toward me is rather like yours when you first came here. He doesn’t see the many ways in which you’ve improved, and he feels threatened in some ways by your improvement That means he isn’t sure whether I’m competent or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s a God damned fool,” Dunne said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But do you feel afraid of him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne was silent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Suppose Sam felt satisfied of my competence? Would that make a difference in his attitude, do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne frowned thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know,” he said. “I guess—but he’s planning to move in with us, and—what the hell can I do about that? Mary says she’ll go along with me now, whatever I decide, but—that bastard still scares me. Still—whenever Sam’s convinced somebody’s okay, he stops pushing. Like that manager of his, Hoyle. The guy’s always right, and Sam’s found that out by now. So he’s stopped arguing so much with Hoyle. I guess it would make a difference. But how can you convince Sam of anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I think a consultation would do it,” Gray explained. Dunne listened thoughtfully as the analyst went into details.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Would Sam have to know what—what I’ve been saying during analysis? I mean—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I know what you mean,” Gray said. “No. And he wouldn’t even be present. He might want his own doctor here, and in that case—even though it would be confidential—I’d make certain I’d say nothing that could be embarrassing. I believe a general sketch of the situation and treatment would be enough. These would be professional people who understand a good deal more about psychotherapy than Sam does. There wouldn’t be any need to go into details.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said, “Well—all right. But—” He frowned again. “How soon could you do it? Sam … he’s going to move in, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He agreed to wait on that until after a consultation. That can be arranged—well, perhaps the day after tomorrow, if we’re lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne said blankly, “He’s not moving in?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He told me he’d do nothing until after the consultation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I haven’t seen him since yesterday,” Dunne said. He reached into his pocket and took out his pipe. “If I’d known—”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne looked almost frightened.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When can I see you again?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When do you want to?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne glanced at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Tomorrow,” he repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“There are alternatives, you know,” Gray said. “We’ve planned one. But there are others.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dunne was silent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve stayed overtime, haven’t I?” he said at last. “I’d better go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not if you don’t want to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But Dunne was on his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s all right now,” he said. “Tomorrow I’ll … well, I’ll see you again. Five o’clock?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, five o’clock will be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ll be here.” Dunne noticed that he was still holding the pipe. He slipped it into his pocket with sudden haste.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray said, on impulse, “You know, I’ve never given you my home phone number.” He scribbled it on his desk pad, tore off the slip, and handed it to Dunne.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Thanks,” Dunne said abstractedly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Call me if you feel like it,” Gray said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure,” Dunne said. “But I won’t need to. It’s all right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He opened the door quickly and went out. The outer door closed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray drew a long breath. He felt very tired. And, more than that, a faint uneasiness that had come in with Dunne had not subsided with his leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He would feel considerably better after the consultation, he decided.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That happened sooner than he expected. A telephone call verified the consultation; Pope’s physician and a psychoanalyst suggested by him were to be present, with Gray, who requested that Dr. Bronson be present too. After some persuasion by Gray, the appointment was fixed for the next day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray had two more patients that evening. His schedule was disarranged, but that could not be helped. Dunne’s needs were pressing now. By the time the psychoanalyst locked his office door, he was tired and ravenous. But he remembered to take with him his notes on Howard Dunne. By tomorrow, he must have the essential data ready for presentation to Bronson and the others.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At home, he worked on the records while he made a sketchy meal. It was past eleven when the telephone rang.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gray got up quickly and crossed the room. But when he lifted the receiver to his ear, there was only a faint buzzing. Gray hesitated. He cradled the phone and stood there waiting and wondering.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ec2d954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/17_chapter13.vue
// module id = 111
// module chunks = 0